import Honeybadger from '@honeybadger-io/js';

import { getStates as getStatesAPI } from 'api/State';

export function facilityProviderData({ practiceId, setStates, navigate }) {
  const getStates = async () => {
    try {
      const res = await getStatesAPI(navigate, { optionify: true });
      setStates(res);
    } catch (error) {
      Honeybadger.notify(`getStates error: ${error}`);
    }
  };

  if (practiceId) getStates();
}
